export default {
  checkout: {
    // Fields

    /*********************************************************************************************
     * User configurable messages
     * TODO: Populate from API
     */
    privacyButton: ' privacy policy',
    privacyPolicyRequiredMessage: 'You must accept the privacy policy to continue.',
    shareRating: 'You scored {0}',
    shareComment: "You said '{n}'",
    shareStaffApplaud: 'You applauded {n}',
    shareSocialSubject: 'I recommend this place!',
    shareSocialMsg: 'I just visited {n}. This is what I thought: #feeditback',
    share: {
      title: 'Thank you for using 125 Data & Insights',
      link: {
        facebook: 'Share on Facebook',
        twitter: 'Share on X',
        email: 'Share via email'
      },
      tip: {
        label: 'Leave a Tip'
      }
    },
    recommend: {
      skip: 'Skip',
      suggestions: {
        title: 'AI generated suggested feedback',
        description: 'Please share your experience',
        copy: 'Copy to clipboard',
        copied: 'Copied',
        copiedToClipboard: 'Copied to clipboard',
        error: 'There is not enough information to generate an informed response',
        generate: 'Generate AI Text'
      }
    },
    email: 'Email',
    emailAlt: 'Share this via email',
    //dynamic use
    facebookAlt: 'Share this via Facebook',
    //dynamic use
    googleAlt: 'Create a review on Google',
    //dynamic use
    thankYouHeader: 'Thank you',
    thankYouPermission: 'Thank you!',
    thankYouVoucher: 'Thank you for your time! We hope you enjoy the voucher.',
    voucherScratchText: "Scratch here to\n     claim your voucher!",
    weAreSorryHeader: 'We are sorry',
    weAreSorryText: 'We are sorry text',
    uploadFileSizeError: 'Your upload must be under {n}',
    uploadError: 'Unknown error',
    uploadDelete: 'Delete photo',
    recaptchaCheckbox: "I'm not a robot"
  }
};